import { useEffect } from 'react'
import { bootstrapDevicesAnalyticsAfterHydration } from './bootstrapAnalyticsAfterHydration'

const AnalyticsPostHydrationBootstrap = () => {
  useEffect(() => {
    bootstrapDevicesAnalyticsAfterHydration()
  }, [])

  return null
}

export default AnalyticsPostHydrationBootstrap
